import React, {useMemo} from "react";
import useLocalStorage from "react-use-localstorage";
import {PieChart} from "@rsuite/charts";

const PieChartWrapper = (props) => {

    const {data, donut = false, title} = props;
    const [theme] = useLocalStorage('theme', 'dark');

    return useMemo(() => {
        return(
            <>
                <p>{title}</p>
                <PieChart
                    data={data}
                    legend={false}
                    name={title}
                    option={{darkMode: (theme === 'dark')}}
                    donut={donut}
                />
            </>
        );
    }, [data, donut, theme, title]);
};

export default PieChartWrapper;